export const DESKTOP_TOP_BAR_HEIGHT = 64
export const MOBILE_TOP_BAR_HEIGHT = 48
export const MOBILE_BOTTOM_BAR_BUTTONS_AREA_HEIGHT = 48

//It's not available at the time of the import, so we need to use a function
//Now it is evaluated at the time of the call, which should be enough
export const getMobileBottomBarPadding = () => {
  const bottomPaddingCssValue = getComputedStyle(document.documentElement).getPropertyValue("--safe-area-bottom")
  return bottomPaddingCssValue ? parseInt(bottomPaddingCssValue, 10) : 0
}
